export const mapPin = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.058 26.108">
    <path
      d="M16.962 8.529c0 3.201-3.983 12.563-6.475 16.416-.92 1.422-2.997 1.422-3.917 0C4.079 21.092.096 11.73.096 8.529.096 3.871 3.871.096 8.529.096s8.433 3.776 8.433 8.433Z"
      style={{
        fill: "#048cba",
        fillRule: "evenodd",
        stroke: "#fff",
        strokeMiterlimit: 10,
        strokeWidth: ".192px",
      }}
    />
    <path
      d="M13.075 8.374c.088 2.379-1.77 4.366-4.142 4.454-2.379.08-4.374-1.77-4.454-4.15-.088-2.371 1.77-4.366 4.15-4.454 2.371-.08 4.366 1.778 4.446 4.15Z"
      style={{
        stroke: "#fff",
        strokeMiterlimit: 10,
        strokeWidth: ".192px",
        fill: "#fff",
      }}
    />
  </svg>
);

export const mapPinDesktop = (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 228.79 490.15"
  >
    <rect
      x="92.17"
      y="114.39"
      width="44.44"
      height="375.76"
      rx="22.22"
      ry="22.22"
      fill="#008db8"
    />
    <circle cx="114.39" cy="114.39" r="114.39" fill="#008db8" />
  </svg>
);
